export default "__VITE_ASSET__os$AlPAi__"